module.exports = __webpack_public_path__ + "7c8ec64d3b5e5e5206dae281fd335d73.svg";